import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { WindowRef } from '@planone/shared/util-browser-api';
import { SnackBarType } from '@planone/shared/util-interfaces';

@Component({
  selector: 'planone-snack-bar',
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.scss'],
})
export class SnackBarComponent {
  cssClass = 'snkbar__icon--neutral';

  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: { type?: SnackBarType; message: string; action: string; closable?: boolean },
    private windowRef: WindowRef,
    private snackRef: MatSnackBarRef<SnackBarComponent>
  ) {
    if (data.type) {
      this.cssClass = 'snkbar__icon--' + data.type;
    }

    this.data = data;
  }

  action() {
    switch (this.data.action) {
      case 'reload':
        this.windowRef.nativeWindow.location.reload();
        break;
      case 'dismiss':
      default:
        this.snackRef.dismiss();
        break;
    }
  }

  close() {
    if (this.data.closable) {
      this.snackRef.dismiss();
    }
  }
}
